class ProductGalleryThumbs extends HTMLElement {
  connectedCallback() {
    if (this.mainSwiper) return;
    if (typeof Swiper === 'undefined') return;

    const mainEl = this.querySelector('.pgt__main');
    const thumbsEl = this.querySelector('.pgt__thumbs');
    const prevEl = this.querySelector('.pgt__nav--prev');
    const nextEl = this.querySelector('.pgt__nav--next');

    if (!mainEl) return;

    const mainSlides = this.querySelectorAll('.pgt__main .swiper-slide');
    const thumbSlides = this.querySelectorAll('.pgt__thumbs .swiper-slide');
    if (thumbSlides.length && mainSlides.length !== thumbSlides.length) {
      console.warn('Product gallery thumbs count mismatch', mainSlides.length, thumbSlides.length);
    }

    if (thumbsEl) {
      this.thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 6,
        spaceBetween: 10,
        watchSlidesProgress: true,
        watchOverflow: true,
        slideToClickedSlide: true,
        // Prevent last thumb right border from being clipped
        slidesOffsetAfter: 1,
        breakpoints: {
          0: {
            slidesPerView: 3,
            spaceBetween: 8,
            slidesOffsetAfter: 1,
          },
           420: {
            slidesPerView: 4,
            spaceBetween: 8,
            slidesOffsetAfter: 1,
          },
          750: {
            slidesPerView: 5,
            spaceBetween: 10,
            slidesOffsetAfter: 1,
          },
          1200: {
            slidesPerView: 6,
            spaceBetween: 12,
            slidesOffsetAfter: 1,
          },
        },
      });
    }

    this.mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 450,
      grabCursor: true,
      watchOverflow: true,
      preventClicks: false,
      preventClicksPropagation: false,
      noSwipingSelector: 'button, a, modal-opener, .product__media-toggle',
      navigation: prevEl && nextEl
        ? {
            prevEl,
            nextEl,
            disabledClass: 'swiper-button-disabled',
          }
        : undefined,
      thumbs: this.thumbsSwiper
        ? {
            swiper: this.thumbsSwiper,
          }
        : undefined,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous image',
        nextSlideMessage: 'Next image',
      },
    });

    this.bindVariantPickerClicks();
  }

  bindVariantPickerClicks() {
    const sectionId = this.dataset.section;
    this.productInfo =
      document.querySelector(`product-info[data-section="${sectionId}"]`) ||
      this.closest('product-info');

    if (!this.productInfo || this._boundVariantLabelClick) return;

    this._boundVariantLabelClick = this.onVariantLabelClick.bind(this);
    this.productInfo.addEventListener('click', this._boundVariantLabelClick);
  }

  onVariantLabelClick(event) {
    const label = event.target.closest('.product-form__input--pill label');
    if (!label) return;

    requestAnimationFrame(() => this.scrollToSelectedVariant());
  }

  getVariantsMediaMap() {
    if (this._variantsMediaMap) return this._variantsMediaMap;

    const el = this.productInfo?.querySelector('[data-variants-media-map]');
    this._variantsMediaMap = el ? JSON.parse(el.textContent) : [];
    return this._variantsMediaMap;
  }

  getSelectedVariant() {
    const variantSelects = this.productInfo?.querySelector('variant-selects');
    if (!variantSelects) return null;

    const selectedOptions = [];
    variantSelects.querySelectorAll('.product-form__input').forEach((inputWrapper) => {
      const select = inputWrapper.querySelector('select');
      const checked = inputWrapper.querySelector('input[type="radio"]:checked');

      if (select) {
        selectedOptions.push(select.value);
      } else if (checked) {
        selectedOptions.push(checked.value);
      }
    });

    if (!selectedOptions.length) return null;

    return this.getVariantsMediaMap().find((variant) =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );
  }

  scrollToSelectedVariant() {
    const variant = this.getSelectedVariant();
    if (!variant?.featured_media_id) return;

    this.setActiveMedia(`${this.dataset.section}-${variant.featured_media_id}`);
  }

  setActiveMedia(mediaId) {
    if (!this.mainSwiper || !mediaId) return;

    const slides = Array.from(this.querySelectorAll('.pgt__main .swiper-slide'));
    const index = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
    if (index < 0) return;

    this.mainSwiper.slideTo(index);
    this.thumbsSwiper?.slideTo?.(index);
  }

  disconnectedCallback() {
    if (this.productInfo && this._boundVariantLabelClick) {
      this.productInfo.removeEventListener('click', this._boundVariantLabelClick);
      this._boundVariantLabelClick = null;
    }

    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
      this.mainSwiper = null;
    }
    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
      this.thumbsSwiper = null;
    }
  }
}

if (!customElements.get('product-gallery-thumbs')) {
  customElements.define('product-gallery-thumbs', ProductGalleryThumbs);
}

document.addEventListener('shopify:section:load', (event) => {
  const gallery = event.target.querySelector('product-gallery-thumbs');
  if (gallery && typeof gallery.connectedCallback === 'function') {
    gallery.connectedCallback();
  }
});
